import { http } from "api/http";

const signin = (data: any) => {
  return http.post("/signin", data);
};

const forgotPassword = (data: any) => {
  return http.post("/forgot-password", data);
};

const resetPassword = (data: any) => {
  return http.post("/reset-password", data);
};

const getUsers = (data: any) => {
  return http.get("/users", data);
};

const getMyProfile = () => {
  return http.get("/users/profile");
};

const updateProfile = (data: any) => {
  return http.patch(`/users/profile`, data);
};

const changePassword = (data: any) => {
  return http.patch(`/change-password`, data);
};

const clientVerifyemail = (data: any) => {
  return http.post("/verifyemail", data);
};

const clientSetPassword = (data: any) => {
  return http.post("/setpassword", data);
};

const getProfile = () => {
  return http.get("/profile");
};

const logout = () => {
  return http.post("/logout");
};

export {
  signin,
  getUsers,
  getMyProfile,
  updateProfile,
  changePassword,
  forgotPassword,
  resetPassword,
  clientVerifyemail,
  clientSetPassword,
  getProfile,
  logout
};
